<template>
  <span
    class="badge"
    v-if="displayCommercialRelation"
    :style="`background-color:${displayCommercialRelation.color}; max-width: fit-content;`"
  >
    {{ displayCommercialRelation.pseudo }}
  </span>
</template>

<script>
export default {
  props: {
    relation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayCommercialRelation() {
      return this.relation?.commercial?.commercial || this.relation;
    },
  },
};
</script>
